import Footer from "../../Components/Footer/Footer"
const FooterPage = () => {
  return (
    <Footer />
  )
}
export default FooterPage